import { __awaiter } from "tslib";
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
export class BaseHttpClient {
    constructor(baseUrl, callbacks, baseHeaders = {}, timeout = 30000) {
        this.onOffLineObserver = undefined;
        this.setAuthorizationHeaders = undefined;
        this.notifyXhrRequestFired = undefined;
        this.notifyError = undefined;
        this.baseHeaders = {};
        this.baseUrl = baseUrl.replace(/$^\//, "");
        this.axiosInstance = axios.create({ timeout });
        this.onOffLineObserver = callbacks.onOffLineObserver;
        this.setAuthorizationHeaders = callbacks.setAuthorizationHeaders;
        this.notifyXhrRequestFired = callbacks.notifyXhrRequestFired;
        this.notifyError = callbacks.notifyError;
        this.baseHeaders = baseHeaders;
        this.timeout = timeout;
    }
    request(_a) {
        return __awaiter(this, arguments, void 0, function* ({ method, url, data, isAnonymous = false, }) {
            var _b, _c, _d, _e, _f, _g, _h, _j;
            if (((_b = this.onOffLineObserver) === null || _b === void 0 ? void 0 : _b.getValue("isOnline")) === false) {
                this.onOffLineObserver.notify();
                return {
                    statusCode: 503,
                    code: "general:onOffLine.offline",
                    message: "The application is offline",
                    data: undefined,
                };
            }
            try {
                const config = {};
                config.headers = Object.assign({}, this.baseHeaders);
                if (this.setAuthorizationHeaders && !isAnonymous) {
                    config.headers = Object.assign(Object.assign({}, config.headers), this.setAuthorizationHeaders());
                }
                config.timeout = this.timeout;
                if (this.timeout > 30000) {
                    config.signal = AbortSignal.timeout(this.timeout);
                }
                if (!isAnonymous && this.notifyXhrRequestFired)
                    this.notifyXhrRequestFired(isAnonymous);
                const callUrl = `${this.baseUrl}/${url
                    .replace(/\/{2,4}/g, "/")
                    .replace(/^\//, "")}`;
                let response;
                let params = undefined;
                switch (method) {
                    case "GET": {
                        if (data)
                            params = { id: data };
                        response = yield this.axiosInstance.get(callUrl, Object.assign(Object.assign({}, config), { params }));
                        break;
                    }
                    case "POST": {
                        response = yield this.axiosInstance.post(callUrl, data, config);
                        break;
                    }
                    case "PUT": {
                        response = yield this.axiosInstance.put(callUrl, data, config);
                        break;
                    }
                    case "DELETE": {
                        response = yield this.axiosInstance.delete(callUrl, Object.assign(Object.assign({}, config), { params: data }));
                        break;
                    }
                    default:
                        break;
                }
                const statusCode = (response === null || response === void 0 ? void 0 : response.status) || 400;
                const responseModel = {
                    data: response === null || response === void 0 ? void 0 : response.data,
                    statusCode,
                };
                return responseModel;
            }
            catch (error) {
                console.log("Error in network request", error);
                const errorResponse = error;
                if (errorResponse.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    const httpCode = errorResponse.response.status || 400;
                    const errRes = errorResponse.response.data;
                    (_c = this.notifyError) === null || _c === void 0 ? void 0 : _c.call(this, httpCode, "response", httpCode === 401 || httpCode === 403
                        ? ((_d = errorResponse.response.data) === null || _d === void 0 ? void 0 : _d.message) || "errors:notAllowed"
                        : error === undefined
                            ? "errors:errorHasOcurred"
                            : typeof errRes === "string"
                                ? errRes
                                : errRes.translationKey ||
                                    errRes.message ||
                                    errorResponse.response.message ||
                                    "errors:errorHasOcurred");
                    return {
                        statusCode: errorResponse.response.status || 400,
                        code: (_e = errorResponse.response.data) === null || _e === void 0 ? void 0 : _e.code,
                        message: ((_f = errorResponse.response.data) === null || _f === void 0 ? void 0 : _f.message) ||
                            ((_g = errorResponse.response.data) === null || _g === void 0 ? void 0 : _g.translationKey) ||
                            "Unknown error",
                        data: undefined,
                    };
                }
                else if (errorResponse.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log("Error request");
                    if (errorResponse.request !== 401)
                        (_h = this.notifyError) === null || _h === void 0 ? void 0 : _h.call(this, 400, "request", "The request was made but no response was received");
                }
                else {
                    // Something happened in setting up the request that triggered an Error
                    console.log("Error");
                    (_j = this.notifyError) === null || _j === void 0 ? void 0 : _j.call(this, 400, "unknown", "Something happened in setting up the request that triggered an Error");
                }
                return {
                    statusCode: 400,
                    code: "",
                    message: "Unknown error",
                    data: undefined,
                };
            }
        });
    }
}
export function isHttpStatusCodeSuccess(statusCode) {
    return statusCode >= 200 && statusCode < 300;
}
